<template>
<div class="chapter">
<div class="inner_page">
<p class="blq-normala"><span class="smallcaps">SOCRATES TO CEBES</span>: <i>Still I suspect that you … are haunted with a fear that when the soul leaves the body the wind may really blow her away and scatter her; especially if a man should happen to die in stormy weather</i>.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frantmatter01.vue?420f325b